// @ts-check
import React from "react"
import Chip from "../atoms/misc/Chip.atom"
import Tooltip from "../atoms/Tooltip.atom"
import { generateRandomId } from "../../utils/strings.utils"
import Badge from "../atoms/Badge.atom"
import {
  VACATION_STATES,
  VACATION_STATES_LABELS,
  VACATION_STATUS_CHIP_VARIANTS,
} from "../../consts/modules/vacations.consts"
import ThumbUpIcon from "@mui/icons-material/ThumbUp"
import ThumbDownIcon from "@mui/icons-material/ThumbDown"
import { ReactComponent as BlockedIcon } from "../../design/assests/images/icons/material_block_filled_icon.svg"
import ClockIcon from "@mui/icons-material/AccessTimeFilled"
import ChangeCircle from "@mui/icons-material/ChangeCircle"
import PaidIcon from "@mui/icons-material/Paid"

/** @type {import("./VacationStatusChip.molecule.types")["VacationStatusChip"]} */
const VacationStatusChip = ({
  status,
  modifierName,
  variant = VACATION_STATUS_CHIP_VARIANTS.SHORT,
  tooltipConfig = {},
  tooltipContent = {
    title: "",
  },
  notification,
  showTooltip,
  pendingDayPlusPay,
  shortLabel = false,
}) => {
  const chipClassName = `vacation-status-chip-${status}-${generateRandomId()}`

  const VACATION_STATUS_ICONS = /** @type {const} */ ({
    [VACATION_STATES.APPROVED_AND_PENDING_PLUS_DAYS_PAY_DATE]: (
      <PaidIcon className="icon" />
    ),
    [VACATION_STATES.APPROVED]: <ThumbUpIcon className="icon" />,
    [VACATION_STATES.PENDING]: <ClockIcon className="icon" />,
    [VACATION_STATES.REJECTED]: <ThumbDownIcon className="icon" />,
    [VACATION_STATES.CANCELED]: (
      <BlockedIcon
        height={14}
        width={14}
        fill="currentColor"
        className="icon"
      />
    ),
    [VACATION_STATES.BLOCKED]: (
      <BlockedIcon
        height={14}
        width={14}
        fill="currentColor"
        className="icon"
      />
    ),
    [VACATION_STATES.CHANGE_REQUEST]: <ChangeCircle className="icon" />,
    [VACATION_STATES.CANCEL_REQUEST]: (
      <BlockedIcon
        height={14}
        width={14}
        fill="currentColor"
        className="icon"
      />
    ),
    [VACATION_STATES.PERIOD_START]: "",
  })

  const label =
    shortLabel ?
      status === VACATION_STATES.CHANGE_REQUEST ? "Cambio"
      : status === VACATION_STATES.CANCEL_REQUEST ? "Cancelación"
      : status === VACATION_STATES.APPROVED && pendingDayPlusPay ?
        "Pago pendiente"
      : VACATION_STATES_LABELS[status]
    : VACATION_STATES_LABELS[status]

  return (
    <>
      <div className="vacation-status-chip-container flex relative w-fit">
        {/* @ts-ignore */}
        <Chip className={chipClassName} label={VACATION_STATUS_ICONS[status]} />
        {variant === VACATION_STATUS_CHIP_VARIANTS.LONG && (
          <div className="vacation-status-chip-status w-fit white-space-nowrap">
            {label}
            {modifierName ? ` por ${modifierName}` : null}
          </div>
        )}
        {notification && <Badge className="vacation-chip-badge" />}
      </div>
      {showTooltip && (
        <Tooltip target={`.${chipClassName}`} {...tooltipConfig}>{tooltipContent.title}</Tooltip>
      )}
    </>
  )
}

export default VacationStatusChip
